<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 {{ title }}
              | &nbsp
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
            br
        .columns(v-show="almacenSelect === ''")
          .column.is-6(v-show="!showGrouped")
            input#all.is-checkradio.is-black(type='radio', value='allC' v-model='filter')
            label.is-size-6(for='all') Todos
            input#irgeC.is-checkradio.is-black(type='radio', value='IRGEc' v-model='filter')
            label.is-size-6(for='irgeC') IRGE
            input#tpaC.is-checkradio.is-black(type='radio', value='TPAc' v-model='filter')
            label.is-size-6(for='tpaC') TPA
            input#corpC.is-checkradio.is-black(type='radio', value='CORPc' v-model='filter')
            label.is-size-6(for='corpC') CORPO
            input#ductoC.is-checkradio.is-black(type='radio', value='DUCTOc' v-model='filter')
            label.is-size-6(for='ductoC') Ducto
          .column.is-6.has-text-right(:class="showGrouped ? 'is-offset-6' : ''")
            input#checkgrouped.is-checkradio.is-black(type='checkbox' v-model='showGrouped')
            label.is-size-6(for='checkgrouped') Agrupar
            | &nbsp
            router-link.a.button.is-black(v-show="permisos.inventarios != 6" to="/Inventario/Alta")
              span.icon
                i.fa.fas.fa-plus
              | &nbspArtículo
            | &nbsp
            a.button.is-success(@click="descargarInventario")
              span.icon
                i.fa.fas.fa-file-download
              | &nbspDescarga
        .columns(v-show="almacenSelect === ''")
          .column.is-6(v-show="!showGrouped")
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='filter')
            label.is-size-6(for='tpaH') TPA GIA
            input#eb04H.is-checkradio.is-black(type='radio', value='EB04' v-model='filter')
            label.is-size-6(for='eb04H') EB04 GIA
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='filter')
            label.is-size-6(for='corpH') CORPO GIA
            input#irgeA.is-checkradio.is-black(type='radio', value='IRGEa' v-model='filter')
            label.is-size-6(for='irgeA') IRGE Activos
          .column.is-5(v-show="!showGrouped" :class="showGrouped ? 'is-offset-7' : 'is-offset-1'")
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Marca | Categoría | Modelo | Serie | NoParte | Partida | Ubicación',
                  v-model="query_articulos",
                )
        .columns(v-show="almacenSelect !== ''")
          .column.is-6
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Marca | Categoría | Modelo | Serie | Partida | No. Parte | Ubicación',
                  v-model="query_articulos",
                )
          .column.is-6.has-text-right
            router-link.a.button.is-black(v-show="permisos.inventarios != 6" to="/Inventario/Alta")
              span.icon
                i.fa.fas.fa-plus
              | &nbspArtículo
            | &nbsp
            a.button.is-success(@click="descargarInventario")
              span.icon
                i.fa.fas.fa-file-download
              | &nbspDescarga
        .columns
          .column.is-5
            nav.pagination.is-rounded.is-small.is-black(role="navigation" aria-label="pagination")
              a.pagination-previous(@click="previusPagina()")
                span.icon
                  i.fas.fa-chevron-left
              a.pagination-next(@click="nextPagina()")
                span.icon
                  i.fas.fa-chevron-right
              ul.pagination-list
                li
                  a.pagination-link(aria-label="Ir a pagina 1" :class="paginaSel == 1 ? 'is-current' : ''" @click="cambiarPagina(1)") 1
                li
                  span.pagination-ellipsis &hellip;
                li
                  a.pagination-link(v-show="paginaIntermedia1" aria-label="Ir a pagina intermeida 1" :class="paginaSel == paginaIntermedia1 ? 'is-current' : ''" @click="cambiarPagina(paginaIntermedia1)") {{ paginaIntermedia1 }}
                li
                  a.pagination-link(v-show="paginaIntermedia2" aria-label="Ir a pagina intermedia 2" :class="paginaSel == paginaIntermedia2 ? 'is-current' : ''" @click="cambiarPagina(paginaIntermedia2)") {{ paginaIntermedia2 }}
                li
                  a.pagination-link(v-show="paginaIntermedia3" aria-label="Ir a pagina intermedia 3" :class="paginaSel == paginaIntermedia3 ? 'is-current' : ''" @click="cambiarPagina(paginaIntermedia3)") {{ paginaIntermedia3 }}
                li
                  span.pagination-ellipsis &hellip;
                li
                  a.pagination-link(v-show="paginaFinal" aria-label="Ir a pagina final" :class="paginaSel == paginaFinal ? 'is-current' : ''" @click="cambiarPagina(paginaFinal)") {{ paginaFinal }}
          .column.is-offset-5.is-3(v-show="resultadoFilter !== ''")
            span.tag.is-warning
              | {{ resultadoFilter }}
        .columns
          .column.is-12(v-show="!showGrouped")
            TbAlmacenes(:origen="origen" :articulos="articulosShow" @updateChildrens="updateArticulos")
          .column.is-12(v-show="showGrouped")
            TbArticulos(:articulos="articulosTotales")
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import TbAlmacenes from './shared/TbAlmacenes.vue'
  import TbArticulos from './TbArticulos.vue'
  import { mapState } from 'vuex'
  export default {
    name: 'ListaArticulos',
    components: { Loader, NavBarInventario, TbAlmacenes, TbArticulos },
    data() {
      return {
        isLoading: true,
        articulos: [],
        articulosShow: [],
        filter: 'allC',
        articulosTotales: [],
        showGrouped: false,
        resultadoFilter: '',
        query_articulos: '',
        almacenes: [],
        origen: {},
        oficinas: [],
        title: '',
        dataPaginas: {
          items: 2925,
          paginas: 30,
        },
        paginaSel: null,
        paginaIntermedia1: null,
        paginaIntermedia2: null,
        paginaIntermedia3: null,
        paginaFinal: null,
        offset: 0,
        limit: 100,
      }
    },
    watch: {
      filter() {
        switch(this.filter) {
          case 'IRGEc':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'IRGE-ALM')
            break
          case 'IRGEa':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'IRGE-ALA')
            break
          case 'TPAc':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'TPA-ALM')
            break
          case 'CORPc':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'CORP-ALM')
            break
          case 'EB04c':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'EB04-ALM')
            break
          case 'EB04':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'EB04-ALG')
            break
          case 'TPA':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'TPA-ALS')
            break
          case 'CORP':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'CORP-ALG')
            break
          case 'DUCTOc':
            this.articulosShow = this.articulos.filter( art => art.oficina === 'EB00-ALM' || art.oficina === 'EB01-ALM' || art.oficina === 'EB02-ALM' || art.oficina === 'EB03-ALM' || art.oficina === 'EB04-ALM')
            break
          case 'allC':
            this.articulosShow = this.articulos
            break
          default:
            break
        }
      },

      query_articulos() {
        this.resultadoFilter = ''
        if (this.query_articulos !== '') {
          this.articulosShow = []
          const QUERY_ARTICULOS = this.query_articulos.toUpperCase()
          const articulos = this.articulos.filter( arts => {
            return `${arts.modelo} ${arts.marca} ${arts.categoria} ${arts.subcategoria} ${arts.serie} 
            ${arts.partida} ${arts.noParte} ${arts.noParte} ${arts.partida} ${arts.localizacion}`.toUpperCase().includes(QUERY_ARTICULOS)
          })
          this.articulosShow = articulos
          this.resultadoFilter = `Coinicidencias: ${this.articulosShow.length} artículo${this.articulosShow.length == 1 ? '' : 's'}`
        } else {
          this.articulosShow = this.articulos
        }
      },

      paginaSel () {
        if (this.paginaSel > 0) {
          if (this.paginaSel == 1 ) {
            this.offset = 0
            this.limit = 100
          } else {
            this.offset = (this.paginaSel - 1) * 100
            this.limit = this.offset + 100
          }
          
          this.obtenerArticulosPaginados()
        } else {
          this.offset = 0
          this.limit = 100
        }
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerTotales()
        this.obtenerAlmacenes()
      },

      obtenerArticulos () {
        if (this.almacenSelect === '') {
          InventarioServices.getArticulos_Ubicacion('ALL')
            .then( data => {
              this.articulos = data.map(this.convertirArticulos)
              this.articulosShow = this.articulos
              this.isLoading = false
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
            })
        } else {
          InventarioServices.getArticulosAlmacen(this.origen.clave)
            .then( data => {
              this.articulos = data.map(this.convertirArticulos)
              this.articulosShow = this.articulos
              this.isLoading = false
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
            })
        }
      },

      convertirArticulos (art) {
        return {
          ...art,
          id: parseInt(art.id),
          cajaChica: parseInt(art.cajaChica),
          estado: parseInt(art.estado),
          garantia: parseInt(art.garantia),
        }
      },

      obtenerTotales () {
        const ubi = this.almacenSelect === '' ? 'ALL' : this.almacenSelect
        InventarioServices.getArticulosUbicacion(ubi)
          .then(res => {
            this.articulosTotales = res.map(this.convetirArticulosTotales)
          })
          .catch((e) => {
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convetirArticulosTotales(data) {
      return {
        ...data,
        exist_CORP: parseInt(data.exist_CORP),
        exist_TPA: parseInt(data.exist_TPA),
        exist_EB04: parseInt(data.exist_EB04),
        exist_CORPc: parseInt(data.exist_CORPc),
        exist_TPAc: parseInt(data.exist_TPAc),
        exist_EB04c: parseInt(data.exist_EB04c),
        exist_IRGEc: parseInt(data.exist_IRGEc),
        exist_IRGEa: parseInt(data.exist_IRGEa),
        exist_Total: parseInt(data.exist_Total),
      }
      },

      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      backPage () {
        this.$router.back()
      },
      
      obtenerAlmacenes () {
        InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convertirAlmacenes)
            this.obtenerOficinas()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convertirAlmacenes (ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          id_oficina: parseInt(ofi.id_oficina),
          id_ubicacion: parseInt(ofi.id_ubicacion),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },

      obtenerOficinas() {
        InventarioServices.getOficinas()
          .then( data => {
            this.oficinas = data.map(this.convertirOficinas)
            this.obtenerAlmacenOrigen()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convertirOficinas(ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          oficina: ofi.nombre,
          id_ubicacion: parseInt(ofi.id_ubicacion),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },

      obtenerAlmacenOrigen() {
        this.almacenes.map( alm => {
          const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
          if (encontrado) {
            this.origen = alm
          }
        })
        this.obtenerPaginacion()
      },

      descargarInventario () {
        this.isLoading = true
        if (this.almacenSelect === '') {
          let nombreFile = ''
          switch (this.filter) {
            case 'allC':
              nombreFile = 'Inventario_General'
              break
            case 'IRGEc':
              nombreFile = 'Inventario_IRGE'
              break
            case 'IRGEa':
              nombreFile = 'Inventario_IRGE_Activos'
              break
            case 'TPAc':
              nombreFile = 'Inventario_TPA'
              break
            case 'CORPc':
              nombreFile = 'Inventario_Corporativo'
              break
            case 'DUCTOc':
              nombreFile = 'Inventario_Ducto'
              break
            case 'TPA':
              nombreFile = 'Inventario_GIA_TPA'
              break
            case 'CORP':
              nombreFile = 'Inventario_GIA_Corporativo'
              break
            case 'EB04':
              nombreFile = 'Inventario_GIA_EB04'
              break
            }
          InventarioServices.createExcel_ubicacion(this.filter, nombreFile)
            .then( res => {
              const currentUrl = window.location.hostname
              if (res.success) {
                open(`https://${currentUrl}/reportesApp/server/excel/generarInventario_Ubicacion.php?nameFile=${res.file}`, '_blank');
                setTimeout(() => {
                  InventarioServices.borrarInventario_Ubicacion(res.file)
                    .then( resDel => {
                      console.log(resDel)
                      this.isLoading = false
                    })
                    .catch((e) => {
                      this.isLoading = false
                      this.displayToast('bubble', e.message, 'ban', 'OK')
                    })
                }, 4000)
              } else {
                this.displayToast('bubble', res.respuesta, 'ban', 'OK')
              }
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast('bubble', e.message, 'ban', 'OK')
            })
        } else {
          let nombreFile = ''
          let ubi = ''
          if (this.almacenSelect === 'c') {
            nombreFile = `Almacen_${this.origen.clave}`
            ubi = this.origen.clave
          } else {
            switch (this.almacenSelect) {
              case 'TPA-ALS':
                nombreFile = 'Almacen_TPA_GIA';
                break;
              case 'EB04-ALG':
                nombreFile = 'Almacen_EB04_GIA';
                break;
              case 'CORP-ALG':
                nombreFile = 'Almacen_CORP_GIA';
                break;
              case 'IRGE-ALM':
                nombreFile = 'Almacen_IRGE';
                break;
              case 'IRGE-ALA':
                nombreFile = 'Almacen_IRGE_Activos';
                break;
              case 'CORP-ALM':
                nombreFile = 'Almacen_CORP';
                break;
              case 'TPA-ALM':
                nombreFile = 'Almacen_TPA';
                break;
              case 'EB04-ALM':
                nombreFile = 'Almacen_EB04';
                break;
              case 'EB00-ALM':
                nombreFile = 'Almacen_EB00';
                break;
              case 'EB01-ALM':
                nombreFile = 'Almacen_EB01';
                break;
              case 'EB02-ALM':
                nombreFile = 'Almacen_EB02';
                break;
              case 'EB03-ALM':
                nombreFile = 'Almacen_EB03';
                break;
              case 'ERM-ALM':
                nombreFile = 'Almacen_ERM';
                break;
              default:
                nombreFile = '';
                break;
            }
            ubi = this.almacenSelect
          }
          console.log(ubi)
          console.log(nombreFile)
          InventarioServices.createExcel_ubicacionSede(ubi, nombreFile)
            .then( res => {
              const currentUrl = window.location.hostname
              if (res.success) {
                open(`https://${currentUrl}/reportesApp/server/excel/generarInventario_Ubicacion.php?nameFile=${res.file}`, '_blank');
                setTimeout(() => {
                  InventarioServices.borrarInventario_Ubicacion(res.file)
                    .then( resDel => {
                      console.log(resDel)
                      this.isLoading = false
                    })
                    .catch((e) => {
                      this.isLoading = false
                      this.displayToast('bubble', e.message, 'ban', 'OK')
                    })
                }, 4000)
              } else {
                this.displayToast('bubble', res.respuesta, 'ban', 'OK')
              }
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast('bubble', e.message, 'ban', 'OK')
            })


          this.isLoading = false
        }
      },

      cambiarPagina(pagina) {
        this.paginaSel = pagina
      },

      previusPagina() {
        const previusPage = this.paginaSel - 1
        if (previusPage <= 0) {
          return false
        }
        
        if (previusPage > 1) {
          console.log('Deberia restar las paginas')
          if (previusPage < this.paginaIntermedia1) {
            this.paginaIntermedia3 = this.paginaIntermedia3 - 1
            this.paginaIntermedia2 = this.paginaIntermedia2 - 1
            this.paginaIntermedia1 = this.paginaIntermedia1 - 1
          }
        }
        this.paginaSel = previusPage
      },

      nextPagina() {
        const nextPagina = this.paginaSel + 1
        if (nextPagina > this.dataPaginas.paginas) {
          return false
        }
        if (nextPagina < this.dataPaginas.paginas) {
          if (nextPagina > this.paginaIntermedia3) {
            this.paginaIntermedia3 = this.paginaIntermedia3 + 1
            this.paginaIntermedia2 = this.paginaIntermedia2 + 1
            this.paginaIntermedia1 = this.paginaIntermedia1 + 1
            
          }
        }
        if (this.paginaSel == this.paginaFinal) {
          this.paginaFinal = this.paginaSel
        }
        this.paginaSel = nextPagina
      },

      obtenerPaginacion() {
        let ubi = ''
        if (this.almacenSelect.length > 1) {
          ubi = this.almacenSelect === '' ? 'ALL' : this.almacenSelect
        } else {
          ubi = this.almacenSelect === '' ? 'ALL' : this.origen.clave
        }
        console.log(ubi)
        InventarioServices.getPaginacionArticulos(ubi)
          .then( data => {
            console.log(data)
            this.dataPaginas = this.convertirPaginacion(data[0])
            if (this.dataPaginas.paginas > 2){
              this.paginaIntermedia1 = 2
            } else {
              this.paginaIntermedia1 = null
            }

            if (this.dataPaginas.paginas > 3){
              this.paginaIntermedia2 = 3
            } else {
              this.paginaIntermedia2 = null
            }

            if (this.dataPaginas.paginas > 4){
              this.paginaIntermedia3 = 4
            } else {
              this.paginaIntermedia3 = null
            }

            if (this.dataPaginas.paginas > 1) {
              this.paginaFinal = this.dataPaginas.paginas
            } else {
              this.paginaFinal = null
            }
            this.paginaSel = 1
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },
      convertirPaginacion(data) {
        return {
          ...data,
          items: parseInt(data.items),
          paginas: parseInt(data.paginas),
        }
      },

      obtenerArticulosPaginados () {
        this.isLoading = true
        this.articulos = []
        this.articulosShow = []
        let ubi = ''
        if (this.almacenSelect.length > 1) {
          ubi = this.almacenSelect === '' ? 'ALL' : this.almacenSelect
        } else {
          ubi = this.almacenSelect === '' ? 'ALL' : this.origen.clave
        }
        InventarioServices.getArticulos_Paginados(ubi, this.offset, this.limit)
          .then( data => {
            this.articulos = data.map(this.convertirArticulos)
            this.articulosShow = this.articulos
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },
      updateArticulos(update) {
        this.filter = 'allC'
        this.iniciarComponente()
        this.obtenerArticulosPaginados()
      },
      backToPage () {
        this.$router.back()
      }
    },

    created () {
      this.iniciarComponente()
      switch (this.almacenSelect) {
        case 'TPA-ALS':
        this.title = 'Artículos en Almacén TPA GIA'
        break
      case 'EB04-ALG':
        this.title = 'Artículos en Almacén EB04 GIA'
        break
      case 'CORP-ALG':
        this.title = 'Artículos en Almacén Corporativo GIA'
        break
      case 'IRGE-ALM':
        this.title = 'Artículos en Almacén IRGE'
        break
      case 'IRGE-ALA':
        this.title = 'Artículos en Almacén Activos'
        break
      case 'CORP-ALM':
        this.title = 'Artículos en Almacén Corporativo'
        break
      case 'TPA-ALM':
        this.title = 'Artículos en Almacén TPA'
        break
      case 'EB04-ALM':
        this.title = 'Artículos en Almacén EB04'
        break
      case 'EB00-ALM':
        this.title = 'Artículos en Almacén EB00'
        break
      case 'EB01-ALM':
        this.title = 'Artículos en Almacén EB01'
        break
      case 'EB02-ALM':
        this.title = 'Artículos en Almacén EB02'
        break
      case 'EB03-ALM':
        this.title = 'Artículos en Almacén EB03'
        break
      case 'ERM-ALM':
        this.title = 'Artículos en Almacén ERM'
        break
      default:
        this.title = 'Artículos en Almacenes'
        break
      }
    },
    
    computed: {
      ...mapState(['userLogin', 'almacenSelect', 'permisos'])
    }

  }
</script>

<style scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ListaArticulos.vue